import { PromotionMatrixStatus } from '../types/promotion-matrix-status.type';
import { ICommissionMatrix } from "./commission-matrix.interface";

export interface IPromotionMatrix {
    id: number;
    name: string;
    maxCommission: number;
    splitMatrixIds: number[];
    splitMatrices: ICommissionMatrix[];
    status: PromotionMatrixStatus;
}
